import get from 'lodash/get';

import { bugsnagError } from 'services/bugsnag';
import warehouse from 'services/warehouse';
import { extractPage } from 'utils/utils';
import Order from 'redux/models/Order';
import OrderDetails from 'redux/models/OrderDetails';

import {
  REQUEST_ORDERS_SUCCESS,
  REQUEST_ORDER_DETAILS_SUCCESS,
  ADD_OR_UPDATE_ORDERS,
  ADD_OR_UPDATE_ORDER_DETAILS,
  REQUEST_ORDERS_LOADING
} from './action-constants';

import {
  getOrdersLoading,
  getOrdersCurrentPage,
  getOrdersNextPage,
  getOrdersPreviousPage
} from './selectors';

const addOrUpdateOrders = orders => ({
  type: ADD_OR_UPDATE_ORDERS,
  payload: orders
});

const addOrUpdateOrderDetails = orderDetails => ({
  type: ADD_OR_UPDATE_ORDER_DETAILS,
  payload: orderDetails
});

export const requestOrderHistory = data => ({
  type: 'REQUEST_ORDER_HISTORY',
  payload: data
});

export const requestOrdersSuccess = ({ ordersData }) => dispatch => {
  const orders = {};

  ordersData.forEach(orderData => {
    const order = Order.createOrderFromWarehouseResponse({ whOrder: orderData });
    orders[order.id()] = order;
  });

  dispatch(addOrUpdateOrders(orders));

  dispatch({
    type: REQUEST_ORDERS_SUCCESS
  });
};

export const requestOrderDetailsSuccess = ({ orderDetailsData }) => dispatch => {
  const orderDetails = OrderDetails.createOrderDetailsFromWarehouseResponse(
    { whOrderDetails: orderDetailsData }
  );

  dispatch(addOrUpdateOrderDetails(orderDetails));

  dispatch({
    type: REQUEST_ORDER_DETAILS_SUCCESS
  });
};

export const requestOrders = ({ page }) => async (dispatch, getState) => {
  if (getOrdersLoading(getState())) { return; }

  dispatch({
    type: REQUEST_ORDERS_LOADING,
    payload: true
  });

  return warehouse.getOrders({ page }).then(responseData => {
    const results = get(responseData, 'results', []);
    const count = get(responseData, 'count', 0);
    const next = get(responseData, 'next', null);
    const previous = get(responseData, 'previous', null);

    // Fetch current page before any updates
    const currentPage = getOrdersCurrentPage(getState());

    // Update next page if new page is greater than current page,
    // update previous page if new page is less than current page,
    // update both by default
    const isFetchingNextPage = currentPage && currentPage < page;
    const isFetchingPreviousPage = currentPage && currentPage > page;

    let paginationData;
    switch (true) {
      case isFetchingNextPage: {
        paginationData = {
          page,
          nextPage: extractPage({ url: next, errorHandler: bugsnagError }),
          previousPage: getOrdersPreviousPage(getState())
        };
        break;
      }
      case isFetchingPreviousPage: {
        paginationData = {
          page,
          // Handle first page which doesn't contain a page number
          previousPage: extractPage({ url: previous, errorHandler: bugsnagError, defaultPage: 1 }),
          nextPage: getOrdersNextPage(getState())
        };
        break;
      }
      default: {
        paginationData = {
          page,
          nextPage: extractPage({ url: next, errorHandler: bugsnagError }),
          previousPage: extractPage({ url: previous, errorHandler: bugsnagError })
        };
        break;
      }
    }

    // Map orders to redux models
    const orders = results.reduce((accum, whOrder) => {
      const order = Order.createOrderFromWarehouseResponse({ whOrder });
      if (order && order.id()) {
        return {
          ...accum,
          [order.id()]: order
        };
      }
      return accum;
    }, {});

    dispatch({
      type: REQUEST_ORDERS_SUCCESS,
      payload: {
        ...paginationData,
        orders,
        count
      }
    });

    dispatch({
      type: REQUEST_ORDERS_LOADING,
      payload: false
    });
  });
};
